/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1CheckIcon20Solid = forwardRef('People1CheckIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.168 6.168a4.167 4.167 0 1 1-8.335 0 4.167 4.167 0 0 1 8.335 0Z" }),
        React.createElement("path", { d: "M15.47 13.14C13.72 12.11 11.452 12 10 12c-2.362 0-6.887.29-7.827 4.369C1.97 17.252 2.735 18 3.641 18h5.053a2.75 2.75 0 0 1 4.25-3.444l.556.555 1.97-1.97Z" }),
        React.createElement("path", { d: "M19.707 14.207a1 1 0 0 0-1.414-1.414L13.5 17.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.146 2.147a1.5 1.5 0 0 0 2.122 0l5.146-5.147Z" })));
});
